// extracted by mini-css-extract-plugin
module.exports = {"container":"Transaction_container__3yJLr","landingContainer":"Transaction_landingContainer__1BlZL","smPadding":"Transaction_smPadding__1FLKi"};